import { render, staticRenderFns } from "./NavManager.vue?vue&type=template&id=dcb5cfa8&scoped=true&"
import script from "./NavManager.vue?vue&type=script&lang=js&"
export * from "./NavManager.vue?vue&type=script&lang=js&"
import style0 from "@/sass/07_elements/users-nav.scss?vue&type=style&index=0&id=dcb5cfa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb5cfa8",
  null
  
)

export default component.exports